import * as api from "Api";
import * as actions from "Actions";

export const fetchExtraSlideList = (
  isHide = "-1",
  searchTitle = "",
  categoryListSelected = null
) => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    let organizationUen = currentOrganization.uen;

    const { paginationPage, pageSize } = getState().extraSlideList;
    let data = {
      paginationPage,
      pageSize,
      organizationUen,
      isHide,
      searchTitle,
      categoryListSelected
    };
    return dispatch(actions.fetchExtraSlideList(api.getExtraSlideList(data)));
  };
};

export const saveExtraSlide = (
  title,
  content,
  extraSlideId = null,
  hide = null,
  categoryId = null
) => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    let organizationUen = currentOrganization.uen;
    return dispatch(
      actions.saveExtraSlide(
        api.saveExtraSlide({
          title,
          content,
          organizationUen,
          extraSlideId,
          hide,
          categoryId
        })
      )
    );
  };
};

export const deleteExtraSlide = extraSlideId => {
  return dispatch => {
    return dispatch(
      actions.deleteExtraSlide(
        api.deleteExtraSlide({
          extraSlideId
        })
      )
    );
  };
};

export const fetchCategoryExtraSlideList = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    let organizationUen = currentOrganization.uen;

    let data = {
      organizationUen
    };
    return dispatch(
      actions.fetchCategoryExtraSlideList(api.getCategoryExtraSlideList(data))
    );
  };
};

export const saveCategoryExtraSlide = (label, categoryId = null) => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    let organizationUen = currentOrganization.uen;
    return dispatch(
      actions.saveCategoryExtraSlide(
        api.saveCategoryExtraSlide({
          organizationUen,
          label,
          categoryId
        })
      )
    );
  };
};

export const deleteCategoryExtraSlide = categoryId => {
  return dispatch => {
    return dispatch(
      actions.deleteCategoryExtraSlide(
        api.deleteCategoryExtraSlide({
          categoryId
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/extraSlideList.js